export class APIException {
  constructor(errors) {
    this._errors = errors
  }
  get errors() {
    return this._errors
  }
}

const processFetch = (response) => {
  if (!response) return {}
  if (response.status === 'Ok') {
    return response
  }

  throw new APIException(response.errors ? response.errors : [response])
}

const request = async ({
  method,
  contentType,
  fetch,
  endpoint,
  getState,
  body,
}) => {
  let response = null

  const viewer = getState().users.viewer

  const options = {
    method,
    headers: {},
  }

  if (contentType) options.headers['Content-Type'] = contentType
  if (viewer) options.headers['x-access-token'] = getState().users.viewer.tokens.access
  if (body) options.body = body

  try {
    response = await fetch(`/api/v1/${endpoint}`, options)
    const responseBody = processFetch(response)

    // if no error return success
    return responseBody
  } catch (e) {
    // process all errors
    if (!response) response = {}
    response.errors = e.errors
    throw response
  }
}

const createGetQuery = (endpoint, query) => {
  if (!query) return endpoint
  const { sort, page, perPage, filters, fields, ...rest } = query
  endpoint += '?'
  if (sort) endpoint += `sort=${sort}&`
  if (page) endpoint += `page=${page}&`
  if (perPage) endpoint += `perPage=${perPage}&`
  if (filters && Object.keys(filters).length) endpoint += `filter=${JSON.stringify(filters)}&`
  if (fields) endpoint += `fields=${JSON.stringify(fields)}&`
  Object.keys(rest).forEach((key) => {
    endpoint += `${key}=${JSON.stringify(rest[key])}&`
  })
  // all queries ends with &. Last character is removed when return
  return endpoint.slice(0, -1)
}

export const apiGet = async ({ fetch, endpoint, getState, query }) => {
  endpoint = createGetQuery(endpoint, query)
  try {
    const body = await request({
      fetch,
      endpoint,
      getState,
      method: 'GET',
      contentType: 'application/json',
    })
    return body
  } catch (e) {
    throw e
  }
}

export const apiPost = async ({ fetch, endpoint, getState, body }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'POST',
      contentType: 'application/json',
      body: JSON.stringify(body),
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPostFile = async ({ fetch, endpoint, getState, body }) => {
  try {
    const formData = new FormData()
    const keys = Object.keys(body)
    keys.forEach((key) => {
      if (Array.isArray(body[key])) {
        for (const k of Object.keys(body[key])) {
          formData.append(key, body[key][k])
        }
      }
      if (body[key]) formData.append(key, body[key])
    })

    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'POST',
      body: formData,
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiPut = async ({ fetch, endpoint, getState, body }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'PUT',
      contentType: 'application/json',
      body: JSON.stringify(body),
    })
    return responseBody
  } catch (e) {
    throw e
  }
}

export const apiDelete = async ({ fetch, endpoint, getState }) => {
  try {
    const responseBody = await request({
      fetch,
      endpoint,
      getState,
      method: 'DELETE',
    })
    return responseBody
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/common/lib/api.js